module.exports = __webpack_public_path__ + "static/media/video_consent_start_record_kannada.83af69cb.mp3";